import { api } from './api';

export const getBoards = () => api.get('/curriculum/boards');
export const getSubjects = (boardId?: string) =>
  api.get('/curriculum/subjects', { params: boardId ? { boardId } : {} });
export const getChapters = (subjectId: string) =>
  api.get(`/curriculum/subjects/${subjectId}/chapters`);
export const createSubject = (data: { name: string; boardId: string; colorHex?: string }) =>
  api.post('/curriculum/subjects', data);
export const createChapter = (data: { name: string; subjectId: string; gradeId: number; sequenceOrder: number }) =>
  api.post('/curriculum/chapters', data);
